<template>
  <v-flex class="pa-2" data-qa="opendeposit-flex-dfaldw">
    <v-layout row wrap data-qa="opendeposit-layout-o8dmq">
      <v-flex lg6 xl6 data-qa="opendeposit-flex-beyd9f">
        <v-flex class="pb-3 font-weight-bold" data-qa="opendeposit-flex-az5xaq">
          <font :color="primaryColor">
          {{ $t("openDepositAcc.depositOption") }}
          </font>
        </v-flex>
        <v-container data-qa="opendeposit-container-f021c">
          <v-row data-qa="opendeposit-row-yn55ys">
            <v-flex class="pb-3 subheading font-weight-bold" xs12 sm4 md4 lg5 xl5 data-qa="opendeposit-flex-yimu5">
              {{ $t("openDepositAcc.fundingAccount") }} :
            </v-flex
              >
            <v-flex xs12 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-ba7nt7">
              <v-radio-group
                @change="onFundingAccountTypeChange"
                v-model="formData.fundingAccount"
                row
                 data-qa="opendeposit-radio-group-eb6fvi">
                <v-radio
                  :color="primaryColor"
                  label="External"
                  value="external"
                  data-qa="external"
                  ></v-radio>
                <v-radio
                  :color="primaryColor"
                  label="Internal"
                  value="internal"
                  data-qa="internal"
                  :disabled="formData.internalAccounts.length === 0"
                  ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-row>
          <v-row data-qa="opendeposit-row-ifyct">
            <v-flex
              v-if="formData.fundingAccount === 'internal'"
              class="open-deposit--label-controls subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-7hel6o">{{ $t("openDepositAcc.accountNumber") }} :</v-flex
              >
            <v-flex
              v-if="formData.fundingAccount === 'external' && formData.externalAccounts && formData.externalAccounts.length"
              class="open-deposit--label-controls subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-eti1w">{{ $t("openDepositAcc.accountAndSortCode") }} :</v-flex
              >
            <v-flex class="open-deposit--selection-controls"
              xs11
              sm6
              md6
              lg6
              xl6 data-qa="opendeposit-flex-znlzik">
              <v-select
                v-if="formData.fundingAccount === 'internal'"
                @input="inputHandler"
                :color="primaryColor"
                class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                :items="formData.internalAccounts"
                item-text="accountId"
                @change="onInternalFundingAccountChange"
                outlined
                v-model="formData.selectedInternalFundingAccount"
                dense
                data-qa="selectInternalAccount"
                ></v-select>
              <v-select
                v-if="formData.fundingAccount === 'external' && formData.externalAccounts && formData.externalAccounts.length"
                :color="primaryColor"
                class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                outlined
                @input="inputHandler"
                @change="selectExternalFunding"
                v-model="formData.selectedExternalFundingAccount"
                :items="formData.externalAccounts"
                dense
                data-qa="selectExternalAccount"
                ></v-select>
            </v-flex>
          </v-row>
          <v-row v-if="formData.fundingAccount === 'internal' && formData.internalFundingAccountBalance.length>0" data-qa="opendeposit-row-oq55bm">
            <v-flex
              class="open-deposit--label-controls subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-8a26t5">{{ $t("openDepositAcc.availableBalanceLabel") }} :</v-flex
              >
            <v-flex class="mt-2" xs12 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-55lfzw">
              <div class="mt-xs-auto mt-sm-auto mt-md-auto mt-n2 mt-xl-auto mb-5 pl-1" data-qa="opendeposit-div-h0e7ko">{{ $formatter.currency.format(formData.internalFundingAccountBalance) }}</div>
            </v-flex>
          </v-row>
          <v-flex v-if="formData.fundingAccount === 'external'" data-qa="opendeposit-flex-6aben8">
            <v-row v-if="!formData.externalAccounts || formData.externalAccounts.length === 0" data-qa="opendeposit-row-32ez3h">
              <v-flex
                class="open-deposit--label-controls subheading font-weight-bold"
                xs12
                sm4
                md4
                lg5
                xl5
                 data-qa="opendeposit-flex-72ot7">{{ $t("openDepositAcc.account") }} :</v-flex
                >
              <v-flex class="open-deposit--selection-controls" xs11 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-qzzve2">
                <v-text-field
                  @input="inputHandler()"
                  class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                  :rules="rules"
                  :color="primaryColor"
                  v-model="formData.fundingAccountNumber"
                  :disabled="formData.externalAccounts && formData.externalAccounts.length > 0"
                  outlined
                  dense
                  data-qa="fundingAccountNumber"
                  ></v-text-field>
              </v-flex>
            </v-row>
            <v-row v-if="!formData.externalAccounts || formData.externalAccounts.length === 0" data-qa="opendeposit-row-rk2eem">
              <v-flex
                class="open-deposit--label-controls subheading font-weight-bold"
                xs12
                sm4
                md4
                lg5
                xl5
                 data-qa="opendeposit-flex-wvyuruh">{{ $t("openDepositAcc.sortCode") }} :</v-flex
                >
              <v-flex class="open-deposit--selection-controls" xs11 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-kin6ga">
                <v-text-field
                  :rules="rules"
                  @input="inputHandler()"
                  class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                  :color="primaryColor"
                  v-model="formData.fundingSortCode"
                  :disabled="formData.externalAccounts && formData.externalAccounts.length > 0"
                  outlined
                  dense
                  data-qa="fundingSordCode"
                  ></v-text-field>
              </v-flex>
            </v-row>
             <v-row  class="mt-n2 pb-4" v-if="!formData.externalAccounts || formData.externalAccounts.length === 0" data-qa="opendeposit-row-boj29">
              <v-flex data-qa="opendeposit-flex-j81iodi"  xs4 sm7 md7 lg7 xl6 class="mr-n4" />
              <v-flex xs4 sm4 md4 lg4 xl6 data-qa="opendeposit-flex-xvlc5e">
                <v-btn
                    :color="primaryColor"
                    @click="createBeneficiaryAccount"
                    :disabled="openBeneficiaryAccValidation()"
                    small
                    class="text-capitalize white--text py-2 px-4"
                    dense
                    data-qa="OpenBeneficiaryAccount"
                  >{{ $t("openDepositAcc.OpenBeneficiaryAccount") }}</v-btn>
              </v-flex>
            </v-row>
          </v-flex>
          <v-row v-if="formData.fundingAccount === 'internal'" data-qa="opendeposit-row-8lu3df">
            <v-flex
              class="open-deposit--label-controls subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-7sydhk">{{ $t("openDepositAcc.depositAmount") }} :</v-flex
              >
            <v-flex
              class="px-4"
              xs12
              sm6
              md6
              lg6
              xl6
               data-qa="opendeposit-flex-kxh49">
              <v-row data-qa="opendeposit-row-ev4iqs">
                <v-flex
                  xs10
                  sm6
                  md6
                  lg6
                  xl6
                   data-qa="opendeposit-flex-f4k42r">
                  <v-text-field
                    :rules="rules"
                    :error="checkAccountBalance().error"
                    :color="primaryColor"
                    @input="inputHandler(); calculateInterestRate()"
                    class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                    v-model="formData.depositAmount"
                    outlined
                    dense
                    data-qa="depositAmount"
                    ></v-text-field>
                </v-flex>
                <v-flex
                  xs2
                  sm6
                  md6
                  lg6
                  xl6
                  class="pt-2"
                   data-qa="opendeposit-flex-1qpaty">
                  {{$appSettings.defaultConfigurations.currencyFormat.currency}}
                  <!-- TODO
                    <v-select
                    :rules="rules"
                    :color="primaryColor"
                    class="mt-n3 mt-sm-auto mt-md-auto mt-lg-auto mt-xl-auto"
                    outlined
                    :label="$t('openDepositAcc.selectCurrencyLabel')"
                    @input="inputHandler"
                    v-model="formData.selectedCurrency"
                    disabled
                    :items="formData.currencies"
                    dense
                     data-qa="opendeposit-select-7a2f4"></v-select> -->
                </v-flex>
                <font class="open-deposit--errorMessages px-1 mt-n6 mt-xs-auto" v-if="checkAccountBalance().error"> {{checkAccountBalance().message}} </font>
              </v-row>
            </v-flex>
          </v-row>
          <v-row data-qa="opendeposit-row-kmw01e">
            <v-flex
              class="open-deposit--label-controls subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-u0upod">{{ $t("openDepositAcc.term") }} :</v-flex
              >
            <v-flex class="px-4" xs12 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-0dnt49">
              <v-row data-qa="opendeposit-row-axuqpd">
                <v-flex
                  xs11
                  sm6
                  md6
                  lg6
                  xl6
                   data-qa="opendeposit-flex-lzhbfd">
                  <v-text-field
                    :rules="rules"
                    :error="checkTermValidation().error"
                    :color="primaryColor"
                    @input="inputHandler(); calculateInterestRate()"
                    v-model="formData.term"
                    outlined
                    dense
                    data-qa="termValidation"
                    ></v-text-field>
                </v-flex>
                <v-flex
                  xs11
                  sm6
                  md6
                  lg6
                  xl6
                   data-qa="opendeposit-flex-quasih">
                  <v-select
                    :rules="rules"
                    :color="primaryColor"
                    outlined
                    :label="$t('openDepositAcc.selectTenorLabel')"
                    @input="inputHandler(); setInterestRate()"
                    v-model="formData.selectedTermOption"
                    :items="formData.termOptions"
                    class="mt-n3 mt-sm-auto mt-md-auto mt-lg-auto mt-xl-auto"
                    dense
                    data-qa="selectedTenor"
                    ></v-select>
                </v-flex>
                <font class="open-deposit--errorMessages px-1 mt-n6 mt-xs-auto" v-if="checkTermValidation().error"> {{checkTermValidation().message}} </font>
              </v-row>
            </v-flex>
          </v-row>
          <v-row data-qa="opendeposit-row-b6e0td">
            <v-flex
              class="open-deposit--label-controls subheading font-weight-bold"
              xs6
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-pm0k63">{{ $t("openDepositAcc.interestRate") }} :</v-flex
              >
            <v-flex class="mt-2" xs4 sm7 md8 lg6 xl6 data-qa="opendeposit-flex-dvwwv">
              <span v-if="formData.fundingAccount === 'internal'" :color="primaryColor" class="mt-xs-auto mt-sm-auto mt-md-auto mt-n2 mt-xl-auto mb-5 mr-3" data-qa="opendeposit-span-b4fqy8">{{ formData.interestRate }}</span>
              <span data-qa="opendeposit-span-5albi">
                <a text class="font-weight-light"
                  style="color: $defaultBorderColor !important"
                  @click="showInterestRates()"
                   data-qa="opendeposit-a-p79ort">{{ $t("applyNow.viewInterestRateLabel")}}
                </a>
              </span>
            </v-flex>
          </v-row>
        </v-container>
      </v-flex>
      <v-flex lg6 xl6 data-qa="opendeposit-flex-odedzf">
        <v-flex class="pb-3 subheading font-weight-bold" data-qa="opendeposit-flex-nw1her">
          <font :color="primaryColor">
          {{ $t("openDepositAcc.maturityInstrunctions") }}
          </font>
        </v-flex>
        <v-container data-qa="opendeposit-container-9e7ux">
          <v-row data-qa="opendeposit-row-s5ckff">
            <v-flex
              class="pb-3 subheading font-weight-bold"
              xs12
              sm4
              md4
              lg5
              xl5
               data-qa="opendeposit-flex-carqyv">{{ $t("openDepositAcc.onMaturity") }} :</v-flex
              >
            <v-flex class="open-deposit--selection-controls" xs11 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-dm83sup">
              <v-select
                dense
                :color="primaryColor"
                outlined
                @input="inputHandler"
                :items="formData.maturityInstructions"
                v-model="formData.selectedMaturityOption"
                item-value="key"
                item-text="value"
                data-qa="maturityInstruction"
                ></v-select>
            </v-flex>
          </v-row>
          <v-row data-qa="opendeposit-row-03bkv">
            <v-flex class="subheading font-weight-bold pb-2" xs12 sm4 md4 lg5 xl5
               data-qa="opendeposit-flex-ttri6e">{{ $t("openDepositAcc.payAwayAccount") }} :</v-flex
              >
            <v-flex xs11 sm6 md6 lg6 xl6 data-qa="opendeposit-flex-d88tf3">
              <v-checkbox
                :color="primaryColor"
                @change="inputHandler"
                v-model="formData.defaultPayAwayAccount"
                :disabled="formData.fundingAccount === 'external' && (!formData.externalAccounts || (formData.externalAccounts && formData.externalAccounts.length === 0))"
                :label="$t('openDepositAcc.sameAsFundingAccount')"
                data-qa="defaultPayawayAccount"
                ></v-checkbox>
            </v-flex>
          </v-row>
          <v-flex v-if="!formData.defaultPayAwayAccount" data-qa="opendeposit-flex-4n81g">
            <v-row data-qa="opendeposit-row-p0a0xk">
              <v-flex
                class="open-deposit--label-controls subheading font-weight-bold"
                xs12
                sm4
                md4
                lg5
                xl5
                 data-qa="opendeposit-flex-sxt87s">{{ formData.fundingAccount === 'external' ? $t("openDepositAcc.payawayAccountAndSortCode") : $t("openDepositAcc.payawayAccountNumber") }} :</v-flex
                >
              <v-flex class="open-deposit--selection-controls"
                xs11
                sm6
                md6
                lg6
                xl6 data-qa="opendeposit-flex-zj85i3">
                <v-select
                  v-if="formData.fundingAccount === 'internal'"
                  :rules="rules"
                  dense
                  item-text="accountId"
                  @input="inputHandler"
                  :color="primaryColor"
                  v-model="formData.selectedInternalPayAwayAccount"
                  outlined
                  :items="formData.internalAccounts"
                  data-qa="selectedInternalPayaway"
                  ></v-select>
                <v-select
                  v-else
                  dense
                  @input="inputHandler"
                  @change="selectExternalFunding"
                  :color="primaryColor"
                  v-model="formData.selectedExternalPayAwayAccount"
                  outlined
                  :items="formData.externalAccounts"
                  data-qa="selectedExternalPayaway"
                  ></v-select>
              </v-flex>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
      <v-flex class="pt-4" xs12 sm12 md12 lg7 xl6 data-qa="opendeposit-flex-1laa6">
        <v-alert
          v-if="formData.fundingAccount === 'external'"
          icon="mdi-information-outline" 
          class="v-alert--info"
         data-qa="opendeposit-alert-gt0nwm">
          {{$t("openDepositConfirm.zeroBalTooltip")}}
        </v-alert>
      </v-flex>
      <!-- OTP Section -->
      <v-flex
        v-if="enableOTP && showOTPScreen"
        class="pt-2 open-deposit--selection-controls"
         data-qa="opendeposit-flex-nfx0o">
        <v-divider data-qa="opendeposit-divider-8wsp8s"  class="pt-2"/>
        <OtpInput :otpConfig="otpSettings" />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import '@/styles/pages/accounts/deposits/openDeposit.scss'
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import _ from 'lodash'
import maturityInstructions from '@/../mocks/maturityInstructions.json'
import OtpInput from '@/components/common/OtpInput.vue'
import store from '@/core/store'
import YM from 'convert-months-year'
const d = new Date()
const month = d.getMonth() + 1
const year = d.getFullYear()

export default {
  name: 'OpenDeposit',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      formData: {
        externalAccounts: [],
        internalAccounts: [],
        currencies: ['GBP'],
        selectedCurrency: 'GBP',
        termOptions: ['Days', 'Months', 'Years'],
        selectedTermOption: 'Months',
        interestRate: '0%',
        defaultPayAwayAccount: true,
        selectedInternalFundingAccount: '',
        selectedExternalFundingAccount: '',
        selectedInternalPayAwayAccount: '',
        selectedExternalPayAwayAccount: '',
        fundingAccount: 'external',
        depositAmount: null,
        term: null,
        selectedMaturityOption: '',
        maturityInstructions,
        fundingAccountNumber: '',
        fundingSortCode: '',
        payawayAccountNumber: '',
        payawaySortCode: '',
        accountBalance: '',
        accountCurrency: '',
        payAwayFundingAccount: 'payAwayExternal',
        payAwayFundingAccountValue: '',
        payAwayAccount: '',
        maturityInstructionsValue: '',
        internalFundingAccountBalance: '',
        internalPayawayAccountBalance: ''
      },
      interestRates: [],
      beneficiaries: null,
      requiredExternalFields: ['fundingAccountNumber', 'fundingSortCode', 'term', 'selectedTermOption', 'selectedMaturityOption'],
      requiredInternalFields: ['selectedInternalFundingAccount', 'depositAmount', 'selectedCurrency', 'term', 'selectedTermOption', 'selectedMaturityOption'],
      rules: [v => Boolean(v) || 'Required'],
      offerInfo: null,
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForCreateTD,
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm6 md5 lg5 xl5'
      },
      minProductTermInDays: 0,
      maxProductTermInDays: 0,
      termInDays: 0,
      beneficiaryDetails: null,
      isBeneficiaryAccountCreated: true,
      isAllFieldsValid: false,
      modalConfig: {
        enabled: false,
        persistent: false,
        saveButton: 'Close',
        outlinedSaveBtn: true,
        title: this.$t('applyNow.modalTitle'),
        width: 800
      },
      headers: [
        { text: 'Minimum Amount', value: 'minAmount' },
        { text: 'Maximum Amount', value: 'maxAmount' },
        { text: 'Minimum Tenor', value: 'minTenor' },
        { text: 'Maximum Tenor', value: 'maxTenor' },
        { text: 'Effective Interest Rate', value: 'effectiveIR' }
      ]
    }
  },
  methods: {
    showInterestRates () {
      this.interestRates = []
      this.modalConfig.enabled = true
      if (!this.offerInfo.interestRates) {
        this.getTDInterestRates()
      } else {
        this.interestRates = this.offerInfo.interestRates
      }
    },
    getTDInterestRates () {
      const self = this
      self.getTermDepositInterestRates().then((res) => {
        for (const i in res.interestRateTiers) {
          const calculatedInterests = {
            ...res.interestRateTiers[i],
            minAmount: self.$formatter.currency.format(res.interestRateTiers[i].balanceFrom),
            maxAmount: self.$formatter.currency.format(res.interestRateTiers[i].balanceTo),
            minTenor: res.interestRateTiers[i].tenorFrom + ' ' + res.duration,
            maxTenor: res.interestRateTiers[i].tenorTo + ' ' + res.duration,
            effectiveIR: res.interestRateTiers[i].interestRate + '%'
          }
          self.interestRates.push(calculatedInterests)
        }
        self.offerInfo.interestRates = self.interestRates
        this.cacheInterestRates()
      })
    },
    cacheInterestRates () {
      const self = this
      const products = JSON.parse(sessionStorage.getItem('products'))
      products.deposit.groups[0].list.map(val => {
        if (val.offerId === this.offerInfo.offerId) {
          val.interestRates = self.offerInfo.interestRates
        }
      })
      sessionStorage.setItem('products', JSON.stringify(products))
    },
    calculateInterestRate () {
      const self = this
      if (this.formData.fundingAccount === 'internal' && self.formData.depositAmount && self.formData.term) {
        if (!this.offerInfo.interestRates) {
          this.getTermDepositInterestRates().then(res => {
            for (const i in res.interestRateTiers) {
              const calculatedInterests = {
                ...res.interestRateTiers[i],
                minAmount: self.$formatter.currency.format(res.interestRateTiers[i].balanceFrom),
                maxAmount: self.$formatter.currency.format(res.interestRateTiers[i].balanceTo),
                minTenor: res.interestRateTiers[i].tenorFrom + ' ' + res.duration,
                maxTenor: res.interestRateTiers[i].tenorTo + ' ' + res.duration,
                effectiveIR: res.interestRateTiers[i].interestRate + '%'
              }
              self.interestRates.push(calculatedInterests)
            }
            self.offerInfo.interestRates = self.interestRates
            self.cacheInterestRates()
            self.setInterestRate()
          })
        } else {
          self.setInterestRate()
        }
      }
    },
    setInterestRate () {
      const self = this
      let termInDays = 0
      let currentYear
      switch (this.formData.selectedTermOption) {
        case 'Months' :
          for (let i = 0; i < this.formData.term; i++) {
            termInDays = termInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'Years' :
          currentYear = year
          for (let i = 0; i < this.formData.term; i++) {
            if (YM.isLeapYear(currentYear)) {
              termInDays = termInDays + 366
            } else {
              termInDays = termInDays + 365
            }
            currentYear++
          }
          break
        default :
          termInDays = this.formData.term
      }
      self.termInDays = termInDays
      if (self.formData.depositAmount && self.formData.term) {
        const x = _.find(self.offerInfo.interestRates, o => {
          return ((parseFloat(self.formData.depositAmount) >= parseFloat(o.balanceFrom) && parseFloat(self.formData.depositAmount) <= parseFloat(o.balanceTo)) && (parseFloat(self.termInDays) >= parseFloat(o.tenorFrom) && parseFloat(self.termInDays) <= parseFloat(o.tenorTo)))
        })
        if (x && x.interestRate) {
          this.formData.interestRate = x.interestRate + '%'
        } else {
          this.formData.interestRate = '0%'
        }
      }
    },
    async getTermDepositInterestRates () {
      return await commonService.getTermDepositInterestRates(this.offerInfo.offerDetails.interestRateId)
    },
    async getActiveCurrencyFromService () {
      const response = await commonService.getActiveCurrencyFromService()
      this.formData.currencies = response.items
      return this.formData.currencies
    },
    async getListOfAccounts (customerId, accType) {
      const accountsWithBal = []
      let response
      if (accType) {
        response = await commonService.getFilteredListOfAccounts(
          customerId,
          accType
        )
      } else {
        response = await commonService.getListOfAccounts(customerId)
        if (response) {
          const x = _.filter(response.items, o => { return o.accountStatus === 'ENABLED' || o.accountStatus === 'ACTIVATED' })
          for (const i in x) {
            const bal = await commonService.getAccountBalances(x[i].accountId)
            if (bal && !bal.causes) {
              accountsWithBal.push(x[i])
            }
          }
        }
      }
      this.formData.internalAccounts = accountsWithBal
    },
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    async createTermDeposit () {
      let termOption = ''
      if (this.formData.selectedTermOption === 'Months') termOption = 'MONTH'
      else if (this.formData.selectedTermOption === 'Years') termOption = 'YEAR'
      else termOption = 'DAY'
      const data = {
        customerId: JSON.parse(sessionStorage.getItem('username')),
        branchCode: store.getters['profileStore/profileData'].customerDetails.branchCode,
        productId: this.offerInfo.offerId,
        startDate: new Date().toISOString().substr(0, 10),
        tenor: {
          frequency: termOption,
          value: parseInt(this.formData.term)
        },
        principal: {
          value: this.formData.fundingAccount === 'external' ? '0' : parseFloat(this.formData.depositAmount),
          currency: this.formData.selectedCurrency
        },
        maturityInstructions: this.formData.selectedMaturityOption,
        accountOwnership: 'SOLE',
        jointCustomerDetails: null,
        modeOfOperation: 'SOLE',
        mandateDetails: null,
        postingsRestriction: 'NONE'
      }
      if (this.formData.fundingAccount === 'internal') {
        data.fundingAccountId = this.formData.selectedInternalFundingAccount
        data.principalPayawayAccountId = this.formData.defaultPayAwayAccount ? this.formData.selectedInternalFundingAccount : this.formData.selectedInternalPayAwayAccount
        data.interestPayawayAccountId = this.formData.defaultPayAwayAccount ? this.formData.selectedInternalFundingAccount : this.formData.selectedInternalPayAwayAccount
      } else {
        data.fundingAccountId = this.formData.selectedExternalFundingAccount
        data.principalPayawayBeneficiaryId = this.beneficiaryDetails.beneficiaryId
        data.interestPayawayBeneficiaryId = this.beneficiaryDetails.beneficiaryId
      }
      const res = await commonService.createTermDepositAccount(data)
      return res
    },
    onFundingAccountTypeChange () {
      this.formData.defaultPayAwayAccount = true
    },
    getFormData (respData) {
      let tenorFrequency = ''
      switch (respData.tenor.frequency) {
        case 'MONTH':
          tenorFrequency = parseInt(respData.tenor.value) > 1 ? 'Months' : 'Month'
          break
        case 'YEAR':
          tenorFrequency = parseInt(respData.tenor.value) > 1 ? 'Years' : 'Year'
          break
        case 'DAY':
          tenorFrequency = parseInt(respData.tenor.value) > 1 ? 'Days' : 'Day'
          break
        default:
          break
      }
      const confirmData = {
        accountDetails: {
          accountNumber: respData.accountId,
          sortCode: respData.branchCode,
          accountStatus: this.$t(`systemEnums.termDeposit.${respData.status}`),
          principalAmount: this.$formatter.currency.format(respData.principal.value),
          interestRate: respData.interestRate + '%',
          tenor: respData.tenor.value + ' ' + tenorFrequency,
          interestPayout: respData.interestPayout || 'Monthly',
          fundingAccount: this.formData.fundingAccount === 'external' ? this.formData.selectedExternalFundingAccount : this.formData.selectedInternalFundingAccount
        },
        maturityDetails: {
          maturityAmount: this.$formatter.currency.format(respData.maturityAmount.value),
          maturityDate: this.$formatter.formatDate(respData.maturityDate),
          onMaturity: this.$t(`systemEnums.maturityInstructions.${respData.maturityInstructions}`),
          payAwayAccount: this.formData.fundingAccount === 'internal' ? respData.principalPayawayAccountId : this.formData.selectedExternalFundingAccount
        }
      }
      if (this.formData.fundingAccount === 'external') {
        delete confirmData.accountDetails.interestRate
        confirmData.maturityDetails.payAwayAccount = this.formData.defaultPayAwayAccount ? this.formData.selectedExternalFundingAccount : this.formData.selectedExternalPayAwayAccount
      }
      return confirmData
    },
    async onInternalFundingAccountChange () {
      const balances = await this.getAccountBalances(this.formData.selectedInternalFundingAccount)
      const bal = _.find(balances, o => { return o.balanceType === 'INTERIMCLEARED' })
      this.formData.internalFundingAccountBalance = bal.amount.amount
    },
    inputHandler () {
      const self = this
      this.checkFieldValidations()
      event.$emit('isDepositOpeningPristine', true)
      setTimeout(() => {
        if (self.formData.fundingAccount === 'external') {
          this.isBeneficiaryAccountCreated = !!self.formData.externalAccounts.length
          self.ifAllRequiredFilled(self.requiredExternalFields)
        } else {
          self.ifAllRequiredFilled(self.requiredInternalFields)
        }
      }, 100)
    },
    checkAccountBalance () {
      if (this.formData.depositAmount && !(/^\d*(\.\d{1,2})?$/.test(this.formData.depositAmount))) {
        return {
          error: true,
          message: this.$t('openDepositAcc.invalidInput')
        }
      }
      if (parseFloat(this.formData.depositAmount) === 0) {
        return {
          error: true,
          message: this.$t('openDepositAcc.zeroBalError')
        }
      }
      if (this.formData.fundingAccount === 'internal') {
        if (this.formData.internalFundingAccountBalance &&
          parseFloat(this.formData.depositAmount) > parseFloat(this.formData.internalFundingAccountBalance)) {
          return {
            error: true,
            message: this.$t('openDepositAcc.availableAccountBalance')
          }
        }
        if (parseFloat(this.formData.depositAmount) < parseFloat(this.offerInfo.info.minAmount[0].value)) {
          return {
            error: true,
            message: this.$t('openDepositAcc.minDepositAmountError')
          }
        }
        if (parseFloat(this.formData.depositAmount) > parseFloat(this.offerInfo.info.maxAmount[0].value)) {
          return {
            error: true,
            message: this.$t('openDepositAcc.maxDepositAmountError')
          }
        }
      }
      if (this.formData.fundingAccount === 'external') {
        if (parseFloat(this.formData.depositAmount) < parseFloat(this.offerInfo.info.minAmount[0].value)) {
          return {
            error: true,
            message: this.$t('openDepositAcc.minDepositAmountError')
          }
        }
        if (parseFloat(this.formData.depositAmount) > parseFloat(this.offerInfo.info.maxAmount[0].value)) {
          return {
            error: true,
            message: this.$t('openDepositAcc.maxDepositAmountError')
          }
        }
      }
      return {
        error: false,
        message: ''
      }
    },
    checkTermValidation () {
      let termInDays = 0
      let currentYear
      if (this.formData.term && !(/^\d+$/.test(this.formData.term))) {
        return {
          error: true,
          message: this.$t('openDepositAcc.invalidInput')
        }
      }
      if (parseFloat(this.formData.term) === 0) {
        return {
          error: true,
          message: this.$t('openDepositAcc.zeroTermError')
        }
      }

      switch (this.formData.selectedTermOption) {
        case 'Months' :
          for (let i = 0; i < this.formData.term; i++) {
            termInDays = termInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'Years' :
          currentYear = year
          for (let i = 0; i < this.formData.term; i++) {
            if (YM.isLeapYear(currentYear)) {
              termInDays = termInDays + 366
            } else {
              termInDays = termInDays + 365
            }
            currentYear++
          }
          break
        default :
          termInDays = this.formData.term
      }
      this.termInDays = termInDays
      if (parseFloat(termInDays) &&
          parseFloat(termInDays) < parseFloat(this.minProductTermInDays)) {
        return {
          error: true,
          message: this.$t('openDepositAcc.minTermError')
        }
      }
      if (parseFloat(termInDays) &&
          parseFloat(termInDays) > parseFloat(this.maxProductTermInDays)) {
        return {
          error: true,
          message: this.$t('openDepositAcc.maxTermError')
        }
      }
      return {
        error: false,
        message: ''
      }
    },
    selectExternalFunding () {
      const self = this
      const a = this.formData.defaultPayAwayAccount ? this.formData.selectedExternalFundingAccount.split(' - ') : this.formData.selectedExternalPayAwayAccount.split(' - ')
      this.formData.fundingAccountNumber = a[0]
      this.formData.fundingSortCode = a[1]
      this.beneficiaryDetails = _.find(self.beneficiaries, o => { return o.accountIdentification === a[0] })
    },
    getRequiredFields (fields) {
      if (!this.formData.defaultPayAwayAccount && this.formData.fundingAccount === 'external') {
        if (this.formData.externalAccounts && this.formData.externalAccounts.length) {
          return _.concat(fields, ['selectedExternalFundingAccount', 'selectedExternalPayAwayAccount'])
        }
      }
      if (this.formData.fundingAccount === 'internal' && !this.formData.defaultPayAwayAccount) {
        return _.concat(fields, ['selectedInternalPayAwayAccount'])
      }
      return fields
    },
    ifAllRequiredFilled (fields) {
      const self = this
      const checked = this.getRequiredFields(fields).every(v => {
        return self.formData[v] && self.formData[v].toString().trim().length > 0
      })
      if (checked && this.isAllFieldsValid) {
        event.$emit('changeStepData', { isConfirmDisabled: false })
      } else {
        event.$emit('changeStepData', { isConfirmDisabled: true })
      }
    },
    async getBeneficiaries () {
      const self = this
      const resp = await commonService.getBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
      if (resp && !resp.causes) {
        self.beneficiaries = resp.items
        self.formData.externalAccounts = []
        for (const i in resp.items) {
          self.formData.externalAccounts.push(resp.items[i].accountIdentification + ' - ' + resp.items[i].bankIdentifier)
        }
      }
    },
    configureMaturityInstruction (type) {
      const a = JSON.stringify(this.formData.maturityInstructions)
      const b = JSON.parse(a)
      switch (type) {
        case 'CUMULATIVE':
          _.remove(b, o => {
            return o.key === 'PAYAWAY-INTEREST' || o.key === 'PAYAWAY-PRINCIPAL'
          })
          this.formData.maturityInstructions = b
          break
        case 'PERIODIC':
          _.remove(b, o => {
            return o.key === 'CAPITALISE' || o.key === 'PAYAWAY-BOTH'
          })
          this.formData.maturityInstructions = b
          break
        case 'PIP':
          _.remove(b, o => {
            return o.key === 'CAPITALISE' || o.key === 'PAYAWAY-BOTH'
          })
          this.formData.maturityInstructions = b
          break
        default : return this.formData.maturityInstructions
      }
    },
    getProductTermDetails () {
      let currentYear
      switch (this.offerInfo.info.minTenor[0].frequency) {
        case 'MONTHS' :
          for (let i = 0; i < this.offerInfo.info.minTenor[0].value; i++) {
            this.minProductTermInDays = this.minProductTermInDays + YM.daysInMonth(month + i, year)
          }
          for (let i = 0; i < this.offerInfo.info.maxTenor[0].value; i++) {
            this.maxProductTermInDays = this.maxProductTermInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'YEARS' :
          currentYear = year
          for (let i = 0; i < this.offerInfo.info.minTenor[0].value; i++) {
            if (YM.isLeapYear(currentYear)) {
              this.minProductTermInDays = this.minProductTermInDays + 366
            } else {
              this.minProductTermInDays = this.minProductTermInDays + 365
            }
            currentYear++
          }
          currentYear = year
          for (let i = 0; i < this.offerInfo.info.maxTenor[0].value; i++) {
            if (YM.isLeapYear(currentYear)) {
              this.maxProductTermInDays = this.maxProductTermInDays + 366
            } else {
              this.maxProductTermInDays = this.maxProductTermInDays + 365
            }
            currentYear++
          }
          break
        default :
          this.minProductTermInDays = this.offerInfo.info.minTenor[0].value
          this.maxProductTermInDays = this.offerInfo.info.maxTenor[0].value
      }
    },
    async createBeneficiaryAccount () {
      const data = {
        customerId: JSON.parse(sessionStorage.getItem('username')),
        name: store.getters['profileStore/profileData'].customerDetails.fullName,
        accountIdentificationType: 'PROPRIETARY',
        accountIdentification: this.formData.fundingAccountNumber,
        country: 'GB',
        currency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
        paymentSystem: 'UKFPS',
        bankIdentifier: this.formData.fundingSortCode
      }
      const resp = await commonService.createBeneficiaryAccount(data)
      if (resp && !resp.causes) {
        this.getBeneficiaries()
      }
    },
    openBeneficiaryAccValidation () {
      if (this.formData.fundingAccountNumber && this.formData.fundingAccountNumber.length > 0 &&
        this.formData.fundingSortCode && this.formData.fundingSortCode.length > 0) {
        return false
      } else return true
    },
    checkFieldValidations () {
      this.isAllFieldsValid = !!(!this.checkAccountBalance().error && !this.checkTermValidation().error)
    }
  },
  beforeCreate () {
    event.$off('onConfirmation', false)
  },
  created () {
    const self = this
    this.showOTPScreen = false
    const routeParamUndefined = {
      info:
          {
            minTenor: [{
              value: '',
              frequency: ''
            }],
            maxTenor: [{
              value: ''
            }],
            minAmount: [{
              value: ''
            }],
            maxAmount: [{
              value: ''
            }]
          },
      offerId: '',
      interestRates: '',
      offerDetails: {
        interestRateId: ''
      }
    }
    if (this.$route.params.item !== undefined) {
      this.offerInfo = this.$route.params.item
    } else {
      this.offerInfo = routeParamUndefined
    }
    this.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    this.getBeneficiaries()
    this.getProductTermDetails()
    this.configureMaturityInstruction(self.offerInfo.offerDetails.interestPayoutMethod)
    event.$emit('changeStepData', { isConfirmDisabled: true })
    event.$on('onConfirmation', val => {
      if (val.name === 'OpenDeposit') {
        if (self.enableOTP && !self.showOTPScreen) {
          self.showOTPScreen = true
          event.$emit('changeStepData', { isConfirmDisabled: true })
        } else {
          self.createTermDeposit().then(resp => {
            if (resp && !resp.causes) {
              event.$emit('onConfirmDeposit', {
                name: 'OpenDeposit',
                value: self.getFormData(resp)
              })
              event.$emit('changeStepData', {
                isConfirmDisabled: false,
                buttonLabel: self.$t('common.accountInquiryLabel'),
                currentStep: val.currentStep + 1
              })
            }
          })
        }
        // TODO: Call API to create account and calculate maturity amount and date
      }
    })
    event.$on('IS_OTP_VALID', valid => {
      if (valid && this.enableOTP && this.showOTPScreen) {
        event.$emit('changeStepData', { isConfirmDisabled: false, buttonLabel: self.$t('common.done') })
      } else {
        event.$emit('changeStepData', { isConfirmDisabled: true })
      }
    })
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
